
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  props: ['user'],
  setup(props) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access Thanks page for not login.')
      router.push({ path: '/login' })
    }
  }
})
